import PropTypes from 'prop-types';
import React from 'react';

import { Table, TableHeader, TableHeading, TableBody, TableRow, TableCell } from '@bibliocommons/table';

import { categoryConfigShape } from 'app/shapes/browse';

const CategoryConfigsList = ({ categoryConfigByLanguageKey, languageKeys, onLanguageKeySelected }) => {
  return (
    <Table>
      <TableHeader>
        <TableHeading>Language</TableHeading>
        <TableHeading>Last updated</TableHeading>
        <TableHeading>Last updated by</TableHeading>
        <TableHeading>Edit</TableHeading>
      </TableHeader>
      <TableBody>
        {languageKeys.map(languageKey => {
          const isNew = !categoryConfigByLanguageKey[languageKey];
          const categoryConfig = categoryConfigByLanguageKey[languageKey] || {
            updatedAt: 0,
            updatedBy: ''
          };

          const onClick = () => onLanguageKeySelected(languageKey);

          return (
            <TableRow key={languageKey}>
              <TableCell>{languageKey}</TableCell>
              <TableCell>{categoryConfig.updatedAt || ''}</TableCell>
              <TableCell>{categoryConfig.updatedBy}</TableCell>
              <TableCell>
                <button onClick={onClick} type="button">
                  {isNew ? 'Create' : 'Edit'}
                </button>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

CategoryConfigsList.propTypes = {
  categoryConfigByLanguageKey: PropTypes.objectOf(categoryConfigShape).isRequired,
  languageKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  onLanguageKeySelected: PropTypes.func.isRequired
};

export default CategoryConfigsList;
